import { Component, OnInit } from '@angular/core';
import { SharingDataService } from 'src/shared/services/sharingData/sharing-data.service';
import { CardService } from 'src/shared/services/card/card.service';
import { Router } from '@angular/router';

import { Card } from '../../models/card.model';
import { TranslatingDataService } from '../../../shared/services/translation/translating-data.service';

@Component({
  selector: 'app-card-recommendation',
  templateUrl: './card-recommendation.component.html',
  styleUrls: ['./card-recommendation.component.css'],
})
export class CardRecommendationComponent implements OnInit {
  constructor(
    public sharingDataService: SharingDataService,
    private cardService: CardService,
    private router: Router
  ) {}
  recommendedCards: Card[] = [];
  isSuccess: boolean = false;
  errorMessage: string;
  ngOnInit(): void {
    let nationality = this.sharingDataService.minimumPaymtCalSharedData.Nationality;
    let monthlyIncome = this.sharingDataService.minimumPaymtCalSharedData.MonthlyIncome;
    let translatedData = this.sharingDataService.minimumPaymtCalSharedData.TranslatedData;

    let incomeUSD =0;
    const numericValue = parseFloat(monthlyIncome.toString().replace(/,/g, ''));       
    if (!isNaN(numericValue)) {
          incomeUSD = Math.round((numericValue / 3.75)*100)/100;
    } else {
      this.errorMessage = translatedData.ErrorList.find(e => e.Id=="GenericError").Text;
    }

    if (translatedData) {
      this.recommendedCards = this.cardService.getRecommendedCardList(
        nationality,
        monthlyIncome,
        incomeUSD,
        translatedData.CardList
      );
      this.isSuccess = true;
    } else {
      //TODO: Handle this.
      this.isSuccess = false;
      this.errorMessage = translatedData.ErrorList.find(e => e.Id=="GenericError").Text;
      console.log('Error:CardList data is null.');
    }
    //this.recommendedCards=this.cardService.getRecommendedCardList(false,45000);
    //console.log(this.recommendedCards);
  }
  selectClickHandler(card: Card) {
    this.sharingDataService.minimumPaymtCalSharedData.SelectedCard = card;
    if(this.sharingDataService.minimumPaymtCalSharedData.SelectedCard.CardCurrency=='USD') {
        const numericValue = parseFloat(this.sharingDataService.minimumPaymtCalSharedData.MonthlyIncome.toString().replace(/,/g, ''));       
        if (!isNaN(numericValue)) {
          this.sharingDataService.minimumPaymtCalSharedData.MonthlyIncome = Math.round((numericValue / 3.75)*100)/100;
        } else {
          this.errorMessage = this.sharingDataService.minimumPaymtCalSharedData.TranslatedData.ErrorList.find(e => e.Id=="GenericError").Text;
        }
    }
  }
  proceedClickHandler() {
    this.router.navigate(['/desiredCreditLimit']);
  }
}
